import React from 'react';
import ServicePage from './ServicePage';
import { IconLeaf, IconFileText, IconShieldCheck } from '../../components/Icons';

const DATA = {
  icon: <IconLeaf size={32} />, category: 'ambiental',
  title: 'PMA – Plan de Manejo Ambiental',
  subtitle: 'Diseño e implementación de Planes de Manejo Ambiental para proyectos mineros y de infraestructura.',
  norm: 'Decreto 1076/2015 – Resolución ANLA',
  desc: 'Elaboramos Planes de Manejo Ambiental integrales para proyectos mineros y de infraestructura, incluyendo todos los programas de manejo requeridos por la autoridad ambiental competente, con enfoque en la sostenibilidad y la protección de ecosistemas.',
  details: [
    'Caracterización ambiental del área de influencia',
    'Identificación y evaluación de impactos (matrices)',
    'Programas: flora, fauna, suelos, agua, aire, comunidades',
    'Plan de contingencia ambiental',
    'Indicadores de seguimiento y monitoreo',
    'Programa de compensación y restauración ecológica',
  ],
  related: [
    { icon: <IconFileText size={18} />,    label: 'Licencias Ambientales', path: '/servicios/licencias' },
    { icon: <IconShieldCheck size={18} />, label: 'ICAS',                   path: '/servicios/icas' },
  ],
};

export default function PMA() { return <ServicePage data={DATA} />; }
